var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocumentPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77753 26.5625H20.2225C22.6485 26.5625 23.8555 25.332 23.8555 22.8945V12.254C23.8555 10.742 23.6915 10.086 22.754 9.125L16.285 2.551C15.395 1.6365 14.668 1.4375 13.344 1.4375H7.77753C5.36353 1.4375 4.14453 2.6795 4.14453 5.1175V22.8945C4.14453 25.3435 5.36353 26.5625 7.77753 26.5625ZM7.87103 24.676C6.66403 24.676 6.03103 24.031 6.03103 22.8595V5.1525C6.03103 3.9925 6.66403 3.324 7.88303 3.324H13.086V10.133C13.086 11.6095 13.836 12.336 15.289 12.336H21.969V22.8595C21.969 24.031 21.3475 24.676 20.129 24.676H7.87103ZM15.5 10.566C15.043 10.566 14.855 10.379 14.855 9.91V3.6875L21.605 10.5665L15.5 10.566Z",
    fill: "#066D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentPage);
export default __webpack_public_path__ + "static/media/icon-document-page.a783b8c607bd45eef85501a3c7fe1e13.svg";
export { ForwardRef as ReactComponent };